var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Computers Devices Electronics  x2F  Power Supply  x2F  phone charger 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4165 16.6667C9.2498 16.6667 8.33313 15.75 8.33313 14.5833V2.08333C8.33313 0.916667 9.2498 0 10.4165 0C11.5831 0 12.4998 0.916667 12.4998 2.08333V14.5833C12.4998 15.75 11.5831 16.6667 10.4165 16.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.7502 16.6667C42.5835 16.6667 41.6669 15.75 41.6669 14.5833V2.08333C41.6669 0.916667 42.5835 0 43.7502 0C44.9169 0 45.8335 0.916667 45.8335 2.08333V14.5833C45.8335 15.75 44.9169 16.6667 43.7502 16.6667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.4169 29.1667H18.7502C17.5835 29.1667 16.6669 28.25 16.6669 27.0833C16.6669 25.9167 17.5835 25 18.7502 25H35.4169C36.5835 25 37.5002 25.9167 37.5002 27.0833C37.5002 28.25 36.5835 29.1667 35.4169 29.1667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.75 100C33.4167 100 25 91.5837 25 81.2503V68.7503C25 67.5837 25.9167 66.667 27.0833 66.667C28.25 66.667 29.1667 67.5837 29.1667 68.7503V81.2503C29.1667 89.292 35.7083 95.8337 43.75 95.8337C51.7917 95.8337 58.3333 89.292 58.3333 81.2503V78.1253C58.3333 64.917 69.0833 54.167 82.2917 54.167H97.9167C99.0833 54.167 100 55.0837 100 56.2503C100 57.417 99.0833 58.3337 97.9167 58.3337H82.2917C71.375 58.3337 62.5 67.2087 62.5 78.1253V81.2503C62.5 91.5837 54.125 100 43.75 100Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.2502 70.8334H22.9169C19.4585 70.8334 16.6669 68.0418 16.6669 64.5834V54.8336C16.6669 53.6669 17.5835 52.7502 18.7502 52.7502C19.9169 52.7502 20.8335 53.6669 20.8335 54.8336V64.5834C20.8335 65.7501 21.7502 66.6668 22.9169 66.6668H31.2502C32.4169 66.6668 33.3335 65.7501 33.3335 64.5834V54.8336C33.3335 53.6669 34.2502 52.7502 35.4169 52.7502C36.5835 52.7502 37.5002 53.6669 37.5002 54.8336V64.5834C37.5002 68.0418 34.7085 70.8334 31.2502 70.8334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.0833 58.3333C12.1667 58.3333 0 46.1667 0 31.25V18.75C0 15.2917 2.79167 12.5 6.25 12.5H47.9167C51.375 12.5 54.1667 15.2917 54.1667 18.75V31.25C54.1667 46.2083 42.0417 58.3333 27.0833 58.3333ZM6.25 16.6667C5.08333 16.6667 4.16667 17.5833 4.16667 18.75V31.25C4.16667 43.875 14.4583 54.1667 27.0833 54.1667C39.7083 54.1667 50 43.875 50 31.25V18.75C50 17.5833 49.0833 16.6667 47.9167 16.6667H6.25Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.40fb2573a9f687b8a30ee795e69b6461.svg";
export { ForwardRef as ReactComponent };